import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

interface UseOrderProductInfoProps {
  hasClassificationTags: boolean;
  imageWidth?: number;
  showSuggestedGrid: boolean;
  clickable: boolean;
}

export const useOrderProductInfoStyles = makeStyles<UseOrderProductInfoProps>()(
  (theme, { imageWidth, showSuggestedGrid, hasClassificationTags, clickable }) => ({
    colorOnHover: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',

      '&:hover': {
        color: theme.palette.primary.main,
        cursor: clickable ? 'pointer' : 'default',
      },
    },

    productImage: {
      marginRight: 8,
      border: `1px solid`,
      borderRadius: '9px',
      width: imageWidth ?? 38,
      minWidth: imageWidth ?? 38,
      borderColor: alpha(theme.palette.custom.border.secondary, 0.8),
    },

    productImageErrorBadge: {
      width: '100%',
      '& > .MuiBadge-anchorOriginTopLeftRectangular': {
        zIndex: 0,
        left: 1,
        top: 3,
      },
    },

    badgeIconWrapper: {
      borderRadius: 100,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.error.main,
      width: 16,
      height: 16,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    productName: {
      color: theme.palette.text.primary,
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      lineHeight: '17px',
      [theme.breakpoints.up('lg')]: {
        WebkitLineClamp: 1,
      },
      [theme.breakpoints.down('lg')]: {
        WebkitLineClamp: hasClassificationTags ? 1 : 2,
      },
    },

    productCode: {
      fontSize: 12,
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 1,
      lineHeight: '17px',
    },

    itemInfo: {
      maxWidth: '90%',

      [theme.breakpoints.only('xs')]: {
        maxWidth: showSuggestedGrid ? '90%' : '70%',
      },
    },

    tagsContainer: {
      display: 'flex',
      alignItems: 'center',
      columnGap: '4px',
      marginTop: 4,
      width: '90%',

      [theme.breakpoints.only('sm')]: {
        width: showSuggestedGrid ? '75%' : '85%',
      },
    },
  }),
);
